import React, { useState } from "react";
import AccountSectionWrapper from "./AccountSectionWrapper";
import AccountActionCard from "../cards/accounts/AccountActionCard";
import AccountDeletionModal from "../popup/AccountDeletionModal";

/**
 * AccountManagement - Renders Account Action Cards and handles Deletion Modal.
 */
const AccountManagement = () => {
  const [isDeletionModalOpen, setIsDeletionModalOpen] = useState(false);

  return (
    <>
      <AccountSectionWrapper title="Account Management" showButton={false}>
        <div
          className="security-content"
          style={{ display: "flex", flexDirection: "column", gap: "12px" }}
        >
          <AccountActionCard
            title="Request Account Deletion"
            description="Your account will remain active while your deletion request is being reviewed. Our team will review your request within 24 business hours. If approved, your account and data eligible for deletion will be permanently removed. Certain information may be retained where required by law."
            buttonText="Request Deletion"
            onAction={() => setIsDeletionModalOpen(true)}
          />
        </div>
      </AccountSectionWrapper>

      {/* Account Deletion Request Popup */}
      {isDeletionModalOpen && (
        <AccountDeletionModal setIsModalOpen={setIsDeletionModalOpen} />
      )}
    </>
  );
};

export default AccountManagement;
